'use strict';

angular.module('theme').service('ZipCodeService', function ($http, ZIPCODES) {

	this.check = function (zipCode) {
		return $http({
			url: '/backapi/zipcode/' + zipCode.replace(' ', ''),
			method: 'GET'
		}).then(function (response) {
			return response.data;
		}, function (response) {
			return response.data;
		});
	};

	this.getDeliveryContactForm = function() {
		return $http({
			url: '/delivery-form/',
			method: 'GET'
		});
	};

	this.zipCodeToCity = function (zipCode) {
		return ZIPCODES[zipCode];
	};
})
.constant('ZIPCODES', {
	'11123': 'Stockholm',
	'11124': 'Stockholm',
	'11127': 'Stockholm',
	'11128': 'Stockholm',
	'11129': 'Stockholm',
	'11130': 'Stockholm',
	'11131': 'Stockholm',
	'11134': 'Stockholm',
	'11135': 'Stockholm',
	'11136': 'Stockholm',
	'11137': 'Stockholm',
	'11138': 'Stockholm',
	'11139': 'Stockholm',
	'11140': 'Stockholm',
	'11143': 'Stockholm',
	'11144': 'Stockholm',
	'11145': 'Stockholm',
	'11146': 'Stockholm',
	'11147': 'Stockholm',
	'11148': 'Stockholm',
	'11149': 'Stockholm',
	'11151': 'Stockholm',
	'11152': 'Stockholm',
	'11153': 'Stockholm',
	'11156': 'Stockholm',
	'11157': 'Stockholm',
	'11160': 'Stockholm',
	'11161': 'Stockholm',
	'11164': 'Stockholm',
	'11215': 'Stockholm',
	'11216': 'Stockholm',
	'11217': 'Stockholm',
	'11218': 'Stockholm',
	'11219': 'Stockholm',
	'11220': 'Stockholm',
	'11221': 'Stockholm',
	'11222': 'Stockholm',
	'11223': 'Stockholm',
	'11224': 'Stockholm',
	'11225': 'Stockholm',
	'11226': 'Stockholm',
	'11227': 'Stockholm',
	'11228': 'Stockholm',
	'11229': 'Stockholm',
	'11230': 'Stockholm',
	'11231': 'Stockholm',
	'11232': 'Stockholm',
	'11233': 'Stockholm',
	'11234': 'Stockholm',
	'11235': 'Stockholm',
	'11236': 'Stockholm',
	'11237': 'Stockholm',
	'11238': 'Stockholm',
	'11239': 'Stockholm',
	'11240': 'Stockholm',
	'11241': 'Stockholm',
	'11242': 'Stockholm',
	'11243': 'Stockholm',
	'11244': 'Stockholm',
	'11245': 'Stockholm',
	'11246': 'Stockholm',
	'11247': 'Stockholm',
	'11248': 'Stockholm',
	'11249': 'Stockholm',
	'11250': 'Stockholm',
	'11251': 'Stockholm',
	'11252': 'Stockholm',
	'11253': 'Stockholm',
	'11254': 'Stockholm',
	'11255': 'Stockholm',
	'11256': 'Stockholm',
	'11257': 'Stockholm',
	'11258': 'Stockholm',
	'11259': 'Stockholm',
	'11260': 'Stockholm',
	'11261': 'Stockholm',
	'11262': 'Stockholm',
	'11263': 'Stockholm',
	'11264': 'Stockholm',
	'11265': 'Stockholm',
	'11266': 'Stockholm',
	'11267': 'Stockholm',
	'11269': 'Stockholm',
	'11320': 'Stockholm',
	'11321': 'Stockholm',
	'11322': 'Stockholm',
	'11323': 'Stockholm',
	'11324': 'Stockholm',
	'11325': 'Stockholm',
	'11326': 'Stockholm',
	'11327': 'Stockholm',
	'11328': 'Stockholm',
	'11329': 'Stockholm',
	'11330': 'Stockholm',
	'11331': 'Stockholm',
	'11332': 'Stockholm',
	'11333': 'Stockholm',
	'11335': 'Stockholm',
	'11336': 'Stockholm',
	'11337': 'Stockholm',
	'11338': 'Stockholm',
	'11339': 'Stockholm',
	'11340': 'Stockholm',
	'11341': 'Stockholm',
	'11342': 'Stockholm',
	'11343': 'Stockholm',
	'11344': 'Stockholm',
	'11345': 'Stockholm',
	'11346': 'Stockholm',
	'11347': 'Stockholm',
	'11348': 'Stockholm',
	'11349': 'Stockholm',
	'11350': 'Stockholm',
	'11351': 'Stockholm',
	'11352': 'Stockholm',
	'11353': 'Stockholm',
	'11354': 'Stockholm',
	'11355': 'Stockholm',
	'11356': 'Stockholm',
	'11357': 'Stockholm',
	'11358': 'Stockholm',
	'11359': 'Stockholm',
	'11360': 'Stockholm',
	'11361': 'Stockholm',
	'11362': 'Stockholm',
	'11364': 'Stockholm',
	'11415': 'Stockholm',
	'11416': 'Stockholm',
	'11417': 'Stockholm',
	'11418': 'Stockholm',
	'11419': 'Stockholm',
	'11420': 'Stockholm',
	'11421': 'Stockholm',
	'11422': 'Stockholm',
	'11423': 'Stockholm',
	'11424': 'Stockholm',
	'11425': 'Stockholm',
	'11426': 'Stockholm',
	'11427': 'Stockholm',
	'11428': 'Stockholm',
	'11429': 'Stockholm',
	'11430': 'Stockholm',
	'11431': 'Stockholm',
	'11432': 'Stockholm',
	'11433': 'Stockholm',
	'11434': 'Stockholm',
	'11435': 'Stockholm',
	'11436': 'Stockholm',
	'11437': 'Stockholm',
	'11438': 'Stockholm',
	'11439': 'Stockholm',
	'11440': 'Stockholm',
	'11441': 'Stockholm',
	'11442': 'Stockholm',
	'11443': 'Stockholm',
	'11444': 'Stockholm',
	'11445': 'Stockholm',
	'11446': 'Stockholm',
	'11447': 'Stockholm',
	'11448': 'Stockholm',
	'11449': 'Stockholm',
	'11450': 'Stockholm',
	'11451': 'Stockholm',
	'11452': 'Stockholm',
	'11453': 'Stockholm',
	'11454': 'Stockholm',
	'11455': 'Stockholm',
	'11456': 'Stockholm',
	'11457': 'Stockholm',
	'11458': 'Stockholm',
	'11459': 'Stockholm',
	'11460': 'Stockholm',
	'11520': 'Stockholm',
	'11521': 'Stockholm',
	'11522': 'Stockholm',
	'11523': 'Stockholm',
	'11524': 'Stockholm',
	'11525': 'Stockholm',
	'11526': 'Stockholm',
	'11527': 'Stockholm',
	'11528': 'Stockholm',
	'11529': 'Stockholm',
	'11530': 'Stockholm',
	'11531': 'Stockholm',
	'11532': 'Stockholm',
	'11533': 'Stockholm',
	'11534': 'Stockholm',
	'11535': 'Stockholm',
	'11536': 'Stockholm',
	'11537': 'Stockholm',
	'11538': 'Stockholm',
	'11539': 'Stockholm',
	'11540': 'Stockholm',
	'11541': 'Stockholm',
	'11542': 'Stockholm',
	'11543': 'Stockholm',
	'11545': 'Stockholm',
	'11550': 'Stockholm',
	'11551': 'Stockholm',
	'11553': 'Stockholm',
	'11557': 'Stockholm',
	'11558': 'Stockholm',
	'11559': 'Stockholm',
	'11620': 'Stockholm',
	'11621': 'Stockholm',
	'11622': 'Stockholm',
	'11623': 'Stockholm',
	'11624': 'Stockholm',
	'11625': 'Stockholm',
	'11628': 'Stockholm',
	'11629': 'Stockholm',
	'11630': 'Stockholm',
	'11631': 'Stockholm',
	'11632': 'Stockholm',
	'11633': 'Stockholm',
	'11634': 'Stockholm',
	'11635': 'Stockholm',
	'11636': 'Stockholm',
	'11637': 'Stockholm',
	'11638': 'Stockholm',
	'11639': 'Stockholm',
	'11640': 'Stockholm',
	'11641': 'Stockholm',
	'11642': 'Stockholm',
	'11643': 'Stockholm',
	'11644': 'Stockholm',
	'11645': 'Stockholm',
	'11646': 'Stockholm',
	'11647': 'Stockholm',
	'11648': 'Stockholm',
	'11661': 'Stockholm',
	'11662': 'Stockholm',
	'11663': 'Stockholm',
	'11664': 'Stockholm',
	'11665': 'Stockholm',
	'11666': 'Stockholm',
	'11667': 'Stockholm',
	'11668': 'Stockholm',
	'11726': 'Stockholm',
	'11727': 'Stockholm',
	'11728': 'Stockholm',
	'11729': 'Stockholm',
	'11730': 'Stockholm',
	'11731': 'Stockholm',
	'11732': 'Stockholm',
	'11733': 'Stockholm',
	'11734': 'Stockholm',
	'11735': 'Stockholm',
	'11736': 'Stockholm',
	'11737': 'Stockholm',
	'11738': 'Stockholm',
	'11739': 'Stockholm',
	'11740': 'Stockholm',
	'11741': 'Stockholm',
	'11743': 'Stockholm',
	'11750': 'Stockholm',
	'11756': 'Stockholm',
	'11757': 'Stockholm',
	'11758': 'Stockholm',
	'11759': 'Stockholm',
	'11760': 'Stockholm',
	'11761': 'Stockholm',
	'11762': 'Stockholm',
	'11763': 'Stockholm',
	'11764': 'Stockholm',
	'11765': 'Stockholm',
	'11766': 'Stockholm',
	'11767': 'Stockholm',
	'11768': 'Stockholm',
	'11769': 'Stockholm',
	'11775': 'Stockholm',
	'11820': 'Stockholm',
	'11821': 'Stockholm',
	'11822': 'Stockholm',
	'11823': 'Stockholm',
	'11824': 'Stockholm',
	'11825': 'Stockholm',
	'11826': 'Stockholm',
	'11827': 'Stockholm',
	'11828': 'Stockholm',
	'11829': 'Stockholm',
	'11830': 'Stockholm',
	'11842': 'Stockholm',
	'11846': 'Stockholm',
	'11847': 'Stockholm',
	'11848': 'Stockholm',
	'11849': 'Stockholm',
	'11850': 'Stockholm',
	'11851': 'Stockholm',
	'11852': 'Stockholm',
	'11853': 'Stockholm',
	'11854': 'Stockholm',
	'11855': 'Stockholm',
	'11856': 'Stockholm',
	'11857': 'Stockholm',
	'11858': 'Stockholm',
	'11859': 'Stockholm',
	'11860': 'Stockholm',
	'11861': 'Stockholm',
	'11862': 'Stockholm',
	'11863': 'Stockholm',
	'11864': 'Stockholm',
	'11865': 'Stockholm',
	'11866': 'Stockholm',
	'11867': 'Stockholm',
	'11869': 'Stockholm',
	'12030': 'Stockholm',
	'12031': 'Stockholm',
	'12038': 'Årsta',
	'12039': 'Årsta',
	'12040': 'Årsta',
	'12044': 'Årsta',
	'12047': 'Enskede GÅRD',
	'12048': 'Enskede GÅRD',
	'12050': 'Årsta',
	'12051': 'Årsta',
	'12052': 'Årsta',
	'12053': 'Årsta',
	'12054': 'Årsta',
	'12055': 'Årsta',
	'12056': 'Årsta',
	'12057': 'Årsta',
	'12058': 'Årsta',
	'12059': 'Årsta',
	'12060': 'Årsta',
	'12061': 'Stockholm',
	'12062': 'Stockholm',
	'12063': 'Stockholm',
	'12064': 'Stockholm',
	'12065': 'Stockholm',
	'12066': 'Stockholm',
	'12067': 'Stockholm',
	'12068': 'Stockholm',
	'12069': 'Stockholm',
	'12070': 'Stockholm',
	'12071': 'Stockholm',
	'12079': 'Stockholm',
	'12130': 'Enskededalen',
	'12131': 'Enskededalen',
	'12132': 'Enskededalen',
	'12133': 'Enskededalen',
	'12134': 'Enskededalen',
	'12135': 'Johanneshov',
	'12136': 'Johanneshov',
	'12137': 'Johanneshov',
	'12138': 'Johanneshov',
	'12139': 'Johanneshov',
	'12140': 'Johanneshov',
	'12143': 'Johanneshov',
	'12144': 'Johanneshov',
	'12145': 'Johanneshov',
	'12146': 'Johanneshov',
	'12147': 'Johanneshov',
	'12148': 'Johanneshov',
	'12149': 'Johanneshov',
	'12150': 'Johanneshov',
	'12151': 'Johanneshov',
	'12152': 'Johanneshov',
	'12153': 'Johanneshov',
	'12154': 'Johanneshov',
	'12155': 'Johanneshov',
	'12156': 'Johanneshov',
	'12162': 'Johanneshov',
	'12163': 'Johanneshov',
	'12177': 'Johanneshov',
	'12231': 'Enskede',
	'12232': 'Enskede',
	'12233': 'Enskede',
	'12234': 'Enskede',
	'12237': 'Enskede',
	'12238': 'Enskede',
	'12239': 'Enskede',
	'12240': 'Enskede',
	'12241': 'Enskede',
	'12242': 'Enskede',
	'12243': 'Enskede',
	'12244': 'Enskede',
	'12245': 'Enskede',
	'12246': 'Enskede',
	'12247': 'Enskede',
	'12248': 'Enskede',
	'12249': 'Enskede',
	'12260': 'Enskede',
	'12262': 'Enskede',
	'12263': 'Enskede',
	'12264': 'Enskede',
	'12265': 'Enskede',
	'12266': 'Enskede',
	'12332': 'Farsta',
	'12333': 'Farsta',
	'12334': 'Farsta',
	'12341': 'Farsta',
	'12342': 'Farsta',
	'12343': 'Farsta',
	'12344': 'Farsta',
	'12346': 'Farsta',
	'12347': 'Farsta',
	'12348': 'Farsta',
	'12349': 'Farsta',
	'12350': 'Farsta',
	'12352': 'Farsta',
	'12355': 'Farsta',
	'12356': 'Farsta',
	'12357': 'Farsta',
	'12358': 'Farsta',
	'12359': 'Farsta',
	'12360': 'Farsta',
	'12363': 'Farsta',
	'12371': 'Farsta',
	'12372': 'Farsta',
	'12373': 'Farsta',
	'12430': 'Bandhagen',
	'12431': 'Bandhagen',
	'12432': 'Bandhagen',
	'12433': 'Bandhagen',
	'12450': 'Bandhagen',
	'12451': 'Bandhagen',
	'12452': 'Bandhagen',
	'12453': 'Bandhagen',
	'12454': 'Bandhagen',
	'12455': 'Bandhagen',
	'12456': 'Bandhagen',
	'12457': 'Bandhagen',
	'12458': 'Bandhagen',
	'12459': 'Bandhagen',
	'12461': 'Bandhagen',
	'12462': 'Bandhagen',
	'12463': 'Bandhagen',
	'12464': 'Bandhagen',
	'12465': 'Bandhagen',
	'12466': 'Bandhagen',
	'12467': 'Bandhagen',
	'12470': 'Bandhagen',
	'12471': 'Bandhagen',
	'12472': 'Bandhagen',
	'12473': 'Bandhagen',
	'12474': 'Bandhagen',
	'12475': 'Bandhagen',
	'12476': 'Bandhagen',
	'12530': 'Älvsjö',
	'12531': 'Älvsjö',
	'12532': 'Älvsjö',
	'12533': 'Älvsjö',
	'12534': 'Älvsjö',
	'12535': 'Älvsjö',
	'12540': 'Älvsjö',
	'12541': 'Älvsjö',
	'12542': 'Älvsjö',
	'12543': 'Älvsjö',
	'12544': 'Älvsjö',
	'12545': 'Älvsjö',
	'12546': 'Älvsjö',
	'12551': 'Älvsjö',
	'12552': 'Älvsjö',
	'12553': 'Älvsjö',
	'12554': 'Älvsjö',
	'12555': 'Älvsjö',
	'12556': 'Älvsjö',
	'12557': 'Älvsjö',
	'12558': 'Älvsjö',
	'12559': 'Älvsjö',
	'12560': 'Älvsjö',
	'12570': 'Älvsjö',
	'12571': 'Älvsjö',
	'12572': 'Älvsjö',
	'12573': 'Älvsjö',
	'12574': 'Älvsjö',
	'12626': 'Hägersten',
	'12628': 'Hägersten',
	'12629': 'Hägersten',
	'12630': 'Hägersten',
	'12631': 'Hägersten',
	'12632': 'Hägersten',
	'12633': 'Hägersten',
	'12634': 'Hägersten',
	'12635': 'Hägersten',
	'12636': 'Hägersten',
	'12637': 'Hägersten',
	'12638': 'Hägersten',
	'12639': 'Hägersten',
	'12640': 'Hägersten',
	'12641': 'Hägersten',
	'12642': 'Hägersten',
	'12647': 'Hägersten',
	'12648': 'Hägersten',
	'12649': 'Hägersten',
	'12650': 'Hägersten',
	'12651': 'Hägersten',
	'12652': 'Hägersten',
	'12653': 'Hägersten',
	'12654': 'Hägersten',
	'12655': 'Hägersten',
	'12677': 'Hägersten',
	'12678': 'Hägersten',
	'12679': 'Hägersten',
	'12730': 'Skärholmen',
	'12731': 'Skärholmen',
	'12732': 'Skärholmen',
	'12733': 'Skärholmen',
	'12734': 'Skärholmen',
	'12736': 'Skärholmen',
	'12737': 'Skärholmen',
	'12738': 'Skärholmen',
	'12739': 'Skärholmen',
	'12740': 'Skärholmen',
	'12741': 'Skärholmen',
	'12742': 'Skärholmen',
	'12743': 'Skärholmen',
	'12744': 'Skärholmen',
	'12745': 'Skärholmen',
	'12746': 'Skärholmen',
	'12747': 'Skärholmen',
	'12748': 'Skärholmen',
	'12749': 'Skärholmen',
	'12755': 'Skärholmen',
	'12761': 'Skärholmen',
	'12830': 'Skarpnäck',
	'12831': 'Skarpnäck',
	'12832': 'Skarpnäck',
	'12833': 'Skarpnäck',
	'12834': 'Skarpnäck',
	'12835': 'Skarpnäck',
	'12836': 'Skarpnäck',
	'12838': 'Skarpnäck',
	'12839': 'Skarpnäck',
	'12841': 'Bagarmossen',
	'12842': 'Bagarmossen',
	'12843': 'Bagarmossen',
	'12844': 'Bagarmossen',
	'12845': 'Bagarmossen',
	'12846': 'Bagarmossen',
	'12847': 'Bagarmossen',
	'12848': 'Bagarmossen',
	'12862': 'Sköndal',
	'12863': 'Sköndal',
	'12864': 'Sköndal',
	'12865': 'Sköndal',
	'12866': 'Sköndal',
	'12867': 'Sköndal',
	'12868': 'Sköndal',
	'12869': 'Sköndal',
	'12930': 'Hägersten',
	'12931': 'Hägersten',
	'12932': 'Hägersten',
	'12933': 'Hägersten',
	'12934': 'Hägersten',
	'12935': 'Hägersten',
	'12936': 'Hägersten',
	'12937': 'Hägersten',
	'12938': 'Hägersten',
	'12939': 'Hägersten',
	'12940': 'Hägersten',
	'12941': 'Hägersten',
	'12942': 'Hägersten',
	'12943': 'Hägersten',
	'12944': 'Hägersten',
	'12945': 'Hägersten',
	'12946': 'Hägersten',
	'12947': 'Hägersten',
	'12948': 'Hägersten',
	'12949': 'Hägersten',
	'12950': 'Hägersten',
	'12951': 'Hägersten',
	'12952': 'Hägersten',
	'12953': 'Hägersten',
	'12954': 'Hägersten',
	'12955': 'Hägersten',
	'12956': 'Hägersten',
	'13025': 'Ingmarsö',
	'13032': 'Grinda',
	'13033': 'Gällnöby',
	'13034': 'Skälvik',
	'13036': 'Nämdö',
	'13038': 'Runmarö',
	'13039': 'Sandhamn',
	'13041': 'Sollenkroka Ö',
	'13042': 'Stavsudda',
	'13043': 'Möja',
	'13044': 'Harö',
	'13055': 'Ornö',
	'13056': 'Utö',
	'13130': 'Nacka',
	'13131': 'Nacka',
	'13132': 'Nacka',
	'13133': 'Nacka',
	'13134': 'Nacka',
	'13135': 'Nacka',
	'13136': 'Nacka',
	'13137': 'Nacka',
	'13138': 'Nacka',
	'13139': 'Nacka',
	'13140': 'Nacka',
	'13141': 'Nacka',
	'13142': 'Nacka',
	'13143': 'Nacka',
	'13144': 'Nacka',
	'13145': 'Nacka',
	'13146': 'Nacka',
	'13147': 'Nacka',
	'13148': 'Nacka',
	'13149': 'Nacka',
	'13150': 'Saltsjö-DUVNÄS',
	'13152': 'Nacka STRAND',
	'13153': 'Nacka',
	'13154': 'Nacka',
	'13155': 'Nacka',
	'13160': 'Nacka',
	'13161': 'Nacka',
	'13162': 'Nacka',
	'13165': 'Nacka',
	'13171': 'Nacka',
	'13172': 'Nacka',
	'13173': 'Nacka',
	'13230': 'Saltsjö-Boo',
	'13231': 'Saltsjö-Boo',
	'13232': 'Saltsjö-Boo',
	'13233': 'Saltsjö-Boo',
	'13234': 'Saltsjö-Boo',
	'13235': 'Saltsjö-Boo',
	'13236': 'Saltsjö-Boo',
	'13237': 'Saltsjö-Boo',
	'13238': 'Saltsjö-Boo',
	'13239': 'Saltsjö-Boo',
	'13240': 'Saltsjö-Boo',
	'13241': 'Saltsjö-Boo',
	'13242': 'Saltsjö-Boo',
	'13243': 'Saltsjö-Boo',
	'13244': 'Saltsjö-Boo',
	'13245': 'Saltsjö-Boo',
	'13246': 'Saltsjö-Boo',
	'13247': 'Saltsjö-Boo',
	'13248': 'Saltsjö-Boo',
	'13249': 'Saltsjö-Boo',
	'13252': 'Saltsjö-Boo',
	'13331': 'Saltsjöbaden',
	'13332': 'Saltsjöbaden',
	'13333': 'Saltsjöbaden',
	'13334': 'Saltsjöbaden',
	'13335': 'Saltsjöbaden',
	'13336': 'Saltsjöbaden',
	'13337': 'Saltsjöbaden',
	'13338': 'Saltsjöbaden',
	'13339': 'Saltsjöbaden',
	'13341': 'Saltsjöbaden',
	'13342': 'Saltsjöbaden',
	'13343': 'Saltsjöbaden',
	'13344': 'Saltsjöbaden',
	'13349': 'Saltsjöbaden',
	'13431': 'Gustavsberg',
	'13432': 'Gustavsberg',
	'13433': 'Gustavsberg',
	'13434': 'Gustavsberg',
	'13435': 'Gustavsberg',
	'13436': 'Gustavsberg',
	'13437': 'Gustavsberg',
	'13438': 'Gustavsberg',
	'13439': 'Gustavsberg',
	'13440': 'Gustavsberg',
	'13441': 'Gustavsberg',
	'13442': 'Gustavsberg',
	'13443': 'Gustavsberg',
	'13444': 'Gustavsberg',
	'13460': 'Ingarö',
	'13461': 'Ingarö',
	'13462': 'Ingarö',
	'13463': 'Ingarö',
	'13464': 'Ingarö',
	'13465': 'Ingarö',
	'13466': 'Ingarö',
	'13467': 'Ingarö',
	'13469': 'Ingarö',
	'13530': 'Tyresö',
	'13533': 'Tyresö',
	'13534': 'Tyresö',
	'13535': 'Tyresö',
	'13536': 'Tyresö',
	'13537': 'Tyresö',
	'13539': 'Tyresö',
	'13540': 'Tyresö',
	'13541': 'Tyresö',
	'13542': 'Tyresö',
	'13543': 'Tyresö',
	'13544': 'Tyresö',
	'13545': 'Tyresö',
	'13546': 'Tyresö',
	'13547': 'Tyresö',
	'13548': 'Tyresö',
	'13549': 'Tyresö',
	'13550': 'Tyresö',
	'13551': 'Tyresö',
	'13552': 'Tyresö',
	'13553': 'Tyresö',
	'13554': 'Tyresö',
	'13555': 'Tyresö',
	'13558': 'Tyresö',
	'13559': 'Tyresö',
	'13560': 'Tyresö',
	'13561': 'Tyresö',
	'13562': 'Tyresö',
	'13563': 'Tyresö',
	'13567': 'Tyresö',
	'13568': 'Tyresö',
	'13569': 'Tyresö',
	'13570': 'Stockholm',
	'13637': 'Handen',
	'13638': 'Handen',
	'13639': 'Handen',
	'13640': 'Handen',
	'13641': 'Handen',
	'13642': 'Handen',
	'13643': 'Handen',
	'13644': 'Handen',
	'13645': 'Handen',
	'13646': 'Handen',
	'13647': 'Haninge',
	'13648': 'Handen',
	'13649': 'Vega',
	'13650': 'Jordbro',
	'13659': 'Vendelsö',
	'13660': 'Brandbergen',
	'13661': 'Brandbergen',
	'13662': 'Brandbergen',
	'13663': 'Brandbergen',
	'13664': 'Haninge',
	'13665': 'Söderby',
	'13666': 'Vendelsö',
	'13667': 'Vendelsö',
	'13668': 'Vendelsö',
	'13669': 'Vendelsö',
	'13670': 'Vendelsö',
	'13671': 'Vendelsö',
	'13672': 'Vendelsö',
	'13673': 'Vendelsö',
	'13674': 'Norrby',
	'13675': 'Vendelsö',
	'13731': 'Västerhaninge',
	'13732': 'Västerhaninge',
	'13734': 'Västerhaninge',
	'13736': 'Västerhaninge',
	'13737': 'Västerhaninge',
	'13738': 'Västerhaninge',
	'13739': 'Västerhaninge',
	'13740': 'Västerhaninge',
	'13741': 'Västerhaninge',
	'13742': 'Västerhaninge',
	'13743': 'Västerhaninge',
	'13754': 'Tungelsta',
	'13755': 'Tungelsta',
	'13756': 'Tungelsta',
	'13757': 'Tungelsta',
	'13761': 'Jordbro',
	'13762': 'Jordbro',
	'13763': 'Jordbro',
	'13764': 'Jordbro',
	'13765': 'Jordbro',
	'13766': 'Jordbro',
	'13767': 'Jordbro',
	'13768': 'Jordbro',
	'13770': 'Dalarö',
	'13771': 'Dalarö',
	'13791': 'Västerhaninge',
	'13792': 'Tungelsta',
	'13793': 'Tungelsta',
	'13794': 'Norra SORUNDA',
	'13795': 'Österhaninge',
	'13796': 'Gålö',
	'13797': 'Årsta HAVSBAD',
	'13830': 'Älta',
	'13831': 'Älta',
	'13832': 'Älta',
	'13833': 'Älta',
	'13834': 'Älta',
	'13835': 'Älta',
	'13836': 'Älta',
	'13837': 'Älta',
	'13839': 'Älta',
	'13840': 'Älta',
	'13930': 'Värmdö',
	'13931': 'Värmdö',
	'13932': 'Värmdö',
	'13933': 'Värmdö',
	'13934': 'Värmdö',
	'13935': 'Värmdö',
	'13936': 'Värmdö',
	'13940': 'Värmdö',
	'13941': 'Värmdö',
	'13950': 'Värmdö',
	'13951': 'Värmdö',
	'13952': 'Värmdö',
	'13953': 'Värmdö',
	'13954': 'Värmdö',
	'13955': 'Värmdö',
	'13956': 'Värmdö',
	'13960': 'Värmdö',
	'13970': 'Stavsnäs',
	'13971': 'Stavsnäs',
	'13972': 'Djurhamn',
	'13973': 'Djurhamn',
	'13974': 'Djurhamn',
	'13975': 'Djurhamn',
	'13990': 'Värmdö',
	'14130': 'Huddinge',
	'14131': 'Huddinge',
	'14132': 'Huddinge',
	'14133': 'Huddinge',
	'14134': 'Huddinge',
	'14135': 'Huddinge',
	'14137': 'Huddinge',
	'14138': 'Huddinge',
	'14139': 'Huddinge',
	'14140': 'Huddinge',
	'14141': 'Huddinge',
	'14142': 'Huddinge',
	'14143': 'Huddinge',
	'14144': 'Huddinge',
	'14145': 'Huddinge',
	'14146': 'Huddinge',
	'14147': 'Huddinge',
	'14148': 'Huddinge',
	'14149': 'Huddinge',
	'14150': 'Huddinge',
	'14151': 'Huddinge',
	'14152': 'Huddinge',
	'14153': 'Huddinge',
	'14154': 'Huddinge',
	'14155': 'Huddinge',
	'14156': 'Huddinge',
	'14159': 'Huddinge',
	'14160': 'Huddinge',
	'14161': 'Huddinge',
	'14162': 'Huddinge',
	'14163': 'Huddinge',
	'14168': 'Huddinge',
	'14169': 'Huddinge',
	'14170': 'Segeltorp',
	'14171': 'Segeltorp',
	'14172': 'Segeltorp',
	'14173': 'Segeltorp',
	'14174': 'Segeltorp',
	'14175': 'Kungens KURVA',
	'14191': 'Huddinge',
	'14192': 'Huddinge',
	'14230': 'Skogås',
	'14231': 'Skogås',
	'14232': 'Skogås',
	'14233': 'Skogås',
	'14234': 'Skogås',
	'14235': 'Skogås',
	'14240': 'Skogås',
	'14241': 'Skogås',
	'14242': 'Skogås',
	'14243': 'Skogås',
	'14250': 'Skogås',
	'14251': 'Skogås',
	'14252': 'Skogås',
	'14260': 'Trångsund',
	'14261': 'Trångsund',
	'14262': 'Trångsund',
	'14263': 'Trångsund',
	'14264': 'Trångsund',
	'14265': 'Trångsund',
	'14266': 'Trångsund',
	'14291': 'Skogås',
	'14330': 'Vårby',
	'14331': 'Vårby',
	'14332': 'Vårby',
	'14340': 'Vårby',
	'14341': 'Vårby',
	'14342': 'Vårby',
	'14343': 'Vårby',
	'14344': 'Vårby',
	'14345': 'Vårby',
	'14346': 'Vårby',
	'14347': 'Vårby',
	'14430': 'Rönninge',
	'14431': 'Rönninge',
	'14432': 'Rönninge',
	'14433': 'Rönninge',
	'14437': 'Rönninge',
	'14440': 'Rönninge',
	'14442': 'Rönninge',
	'14444': 'Rönninge',
	'14451': 'Rönninge',
	'14452': 'Rönninge',
	'14461': 'Rönninge',
	'14462': 'Rönninge',
	'14463': 'Rönninge',
	'14464': 'Rönninge',
	'14550': 'Norsborg',
	'14551': 'Norsborg',
	'14552': 'Norsborg',
	'14553': 'Norsborg',
	'14556': 'Norsborg',
	'14557': 'Norsborg',
	'14558': 'Norsborg',
	'14559': 'Norsborg',
	'14560': 'Norsborg',
	'14563': 'Norsborg',
	'14564': 'Norsborg',
	'14565': 'Norsborg',
	'14567': 'Norsborg',
	'14568': 'Norsborg',
	'14569': 'Norsborg',
	'14570': 'Norsborg',
	'14571': 'Norsborg',
	'14572': 'Norsborg',
	'14573': 'Norsborg',
	'14574': 'Norsborg',
	'14590': 'Norsborg',
	'14630': 'Tullinge',
	'14631': 'Tullinge',
	'14632': 'Tullinge',
	'14633': 'Tullinge',
	'14634': 'Tullinge',
	'14636': 'Tullinge',
	'14637': 'Tullinge',
	'14638': 'Tullinge',
	'14640': 'Tullinge',
	'14641': 'Tullinge',
	'14645': 'Tullinge',
	'14646': 'Tullinge',
	'14648': 'Tullinge',
	'14649': 'Tullinge',
	'14650': 'Tullinge',
	'14652': 'Tullinge',
	'14653': 'Tullinge',
	'14654': 'Tullinge',
	'14730': 'Tumba',
	'14731': 'Tumba',
	'14732': 'Tumba',
	'14733': 'Tumba',
	'14734': 'Tumba',
	'14739': 'Tumba',
	'14740': 'Tumba',
	'14741': 'Tumba',
	'14742': 'Tumba',
	'14743': 'Tumba',
	'14744': 'Tumba',
	'14745': 'Tumba',
	'14746': 'Tumba',
	'14750': 'Tumba',
	'14751': 'Tumba',
	'14752': 'Tumba',
	'14753': 'Tumba',
	'14754': 'Tumba',
	'14755': 'Tumba',
	'14760': 'Uttran',
	'14761': 'Uttran',
	'14762': 'Uttran',
	'14763': 'Uttran',
	'14770': 'Grödinge',
	'14771': 'Grödinge',
	'14791': 'Grödinge',
	'14792': 'Grödinge',
	'14830': 'Ösmo',
	'14831': 'Ösmo',
	'14832': 'Ösmo',
	'14833': 'Ösmo',
	'14834': 'Ösmo',
	'14835': 'Ösmo',
	'14840': 'Segersäng',
	'14860': 'Stora VIKA',
	'14870': 'Sorunda',
	'14871': 'Sorunda',
	'14891': 'Ösmo',
	'14892': 'Ösmo',
	'14895': 'Muskö',
	'14896': 'Sorunda',
	'14897': 'Sorunda',
	'14930': 'Nynäshamn',
	'14931': 'Nynäshamn',
	'14932': 'Nynäshamn',
	'14933': 'Nynäshamn',
	'14934': 'Nynäshamn',
	'14935': 'Nynäshamn',
	'14940': 'Nynäshamn',
	'14941': 'Nynäshamn',
	'14943': 'Nynäshamn',
	'14945': 'Nynäshamn',
	'14950': 'Nynäshamn',
	'14951': 'Nynäshamn',
	'14991': 'Nynäshamn',
	'14992': 'Nynäshamn',
	'14995': 'Nynäshamn',
	'15132': 'Södertälje',
	'15133': 'Södertälje',
	'15134': 'Södertälje',
	'15135': 'Södertälje',
	'15136': 'Södertälje',
	'15137': 'Södertälje',
	'15138': 'Södertälje',
	'15139': 'Södertälje',
	'15140': 'Södertälje',
	'15144': 'Södertälje',
	'15145': 'Södertälje',
	'15146': 'Södertälje',
	'15147': 'Södertälje',
	'15148': 'Södertälje',
	'15150': 'Enhörna',
	'15152': 'Södertälje',
	'15153': 'Södertälje',
	'15154': 'Södertälje',
	'15155': 'Södertälje',
	'15156': 'Södertälje',
	'15157': 'Södertälje',
	'15159': 'Södertälje',
	'15160': 'Södertälje',
	'15161': 'Södertälje',
	'15162': 'Södertälje',
	'15163': 'Södertälje',
	'15164': 'Södertälje',
	'15165': 'Södertälje',
	'15166': 'Södertälje',
	'15168': 'Södertälje',
	'15171': 'Södertälje',
	'15172': 'Södertälje',
	'15173': 'Södertälje',
	'15196': 'Enhörna',
	'15230': 'Södertälje',
	'15231': 'Södertälje',
	'15240': 'Södertälje',
	'15241': 'Södertälje',
	'15242': 'Södertälje',
	'15243': 'Södertälje',
	'15248': 'Södertälje',
	'15249': 'Södertälje',
	'15250': 'Södertälje',
	'15251': 'Södertälje',
	'15252': 'Södertälje',
	'15254': 'Södertälje',
	'15256': 'Södertälje',
	'15257': 'Södertälje',
	'15258': 'Södertälje',
	'15259': 'Södertälje',
	'15270': 'Södertälje',
	'15271': 'Södertälje',
	'15295': 'Södertälje',
	'15297': 'Södertälje',
	'15330': 'Järna',
	'15331': 'Järna',
	'15332': 'Järna',
	'15335': 'Järna',
	'15336': 'Järna',
	'15337': 'Järna',
	'15338': 'Järna',
	'15360': 'Mölnbo',
	'15371': 'Hölö',
	'15391': 'Järna',
	'15392': 'Hölö',
	'15393': 'Mörkö',
	'15394': 'Hölö',
	'15395': 'Järna',
	'15396': 'Mölnbo',
	'15530': 'Nykvarn',
	'15531': 'Nykvarn',
	'15532': 'Nykvarn',
	'15533': 'Nykvarn',
	'15534': 'Nykvarn',
	'15591': 'Nykvarn',
	'15592': 'Nykvarn',
	'15593': 'Nykvarn',
	'15594': 'Nykvarn',
	'16243': 'Vällingby',
	'16244': 'Vällingby',
	'16245': 'Vällingby',
	'16246': 'Vällingby',
	'16247': 'Vällingby',
	'16250': 'Vällingby',
	'16252': 'Vällingby',
	'16253': 'Vällingby',
	'16254': 'Vällingby',
	'16255': 'Vällingby',
	'16256': 'Vällingby',
	'16257': 'Vällingby',
	'16258': 'Vällingby',
	'16260': 'Vällingby',
	'16261': 'Vällingby',
	'16262': 'Vällingby',
	'16263': 'Vällingby',
	'16264': 'Vällingby',
	'16265': 'Vällingby',
	'16266': 'Vällingby',
	'16267': 'Vällingby',
	'16268': 'Vällingby',
	'16270': 'Vällingby',
	'16271': 'Vällingby',
	'16272': 'Vällingby',
	'16273': 'Vällingby',
	'16340': 'Spånga',
	'16341': 'Spånga',
	'16342': 'Spånga',
	'16343': 'Spånga',
	'16344': 'Spånga',
	'16345': 'Spånga',
	'16346': 'Spånga',
	'16347': 'Spånga',
	'16350': 'Spånga',
	'16351': 'Spånga',
	'16352': 'Spånga',
	'16353': 'Spånga',
	'16354': 'Spånga',
	'16355': 'Spånga',
	'16356': 'Spånga',
	'16361': 'Spånga',
	'16362': 'Spånga',
	'16363': 'Spånga',
	'16364': 'Spånga',
	'16365': 'Spånga',
	'16366': 'Spånga',
	'16367': 'Spånga',
	'16368': 'Spånga',
	'16370': 'Spånga',
	'16371': 'Spånga',
	'16372': 'Spånga',
	'16373': 'Spånga',
	'16374': 'Spånga',
	'16375': 'Spånga',
	'16430': 'Kista',
	'16431': 'Kista',
	'16432': 'Kista',
	'16433': 'Kista',
	'16434': 'Kista',
	'16435': 'Kista',
	'16436': 'Kista',
	'16437': 'Kista',
	'16438': 'Kista',
	'16439': 'Kista',
	'16440': 'Kista',
	'16441': 'Kista',
	'16442': 'Kista',
	'16443': 'Kista',
	'16444': 'Kista',
	'16445': 'Kista',
	'16446': 'Kista',
	'16447': 'Kista',
	'16448': 'Kista',
	'16453': 'Kista',
	'16455': 'Kista',
	'16471': 'Kista',
	'16472': 'Kista',
	'16473': 'Kista',
	'16474': 'Kista',
	'16475': 'Kista',
	'16476': 'Kista',
	'16477': 'Kista',
	'16478': 'Kista',
	'16479': 'Kista',
	'16552': 'Hässelby',
	'16553': 'Hässelby',
	'16554': 'Hässelby',
	'16555': 'Hässelby',
	'16556': 'Hässelby',
	'16557': 'Hässelby',
	'16558': 'Hässelby',
	'16559': 'Hässelby',
	'16560': 'Hässelby',
	'16561': 'Hässelby',
	'16562': 'Hässelby',
	'16563': 'Hässelby',
	'16564': 'Hässelby',
	'16565': 'Hässelby',
	'16566': 'Hässelby',
	'16570': 'Hässelby',
	'16571': 'Hässelby',
	'16572': 'Hässelby',
	'16573': 'Hässelby',
	'16574': 'Hässelby',
	'16575': 'Hässelby',
	'16576': 'Hässelby',
	'16577': 'Hässelby',
	'16578': 'Hässelby',
	'16731': 'Bromma',
	'16732': 'Bromma',
	'16733': 'Bromma',
	'16735': 'Bromma',
	'16736': 'Bromma',
	'16737': 'Bromma',
	'16738': 'Bromma',
	'16739': 'Bromma',
	'16740': 'Bromma',
	'16741': 'Bromma',
	'16743': 'Bromma',
	'16744': 'Bromma',
	'16745': 'Bromma',
	'16751': 'Bromma',
	'16752': 'Bromma',
	'16753': 'Bromma',
	'16754': 'Bromma',
	'16755': 'Bromma',
	'16756': 'Bromma',
	'16757': 'Bromma',
	'16758': 'Bromma',
	'16761': 'Bromma',
	'16762': 'Bromma',
	'16763': 'Bromma',
	'16764': 'Bromma',
	'16765': 'Bromma',
	'16766': 'Bromma',
	'16767': 'Bromma',
	'16771': 'Bromma',
	'16772': 'Bromma',
	'16773': 'Bromma',
	'16774': 'Bromma',
	'16775': 'Bromma',
	'16776': 'Bromma',
	'16830': 'Bromma',
	'16831': 'Bromma',
	'16832': 'Bromma',
	'16833': 'Bromma',
	'16834': 'Bromma',
	'16835': 'Bromma',
	'16836': 'Bromma',
	'16837': 'Bromma',
	'16838': 'Bromma',
	'16839': 'Bromma',
	'16840': 'Bromma',
	'16841': 'Bromma',
	'16843': 'Bromma',
	'16844': 'Bromma',
	'16845': 'Bromma',
	'16846': 'Bromma',
	'16847': 'Bromma',
	'16848': 'Bromma',
	'16849': 'Bromma',
	'16850': 'Bromma',
	'16851': 'Bromma',
	'16852': 'Bromma',
	'16853': 'Bromma',
	'16854': 'Bromma',
	'16855': 'Bromma',
	'16856': 'Bromma',
	'16857': 'Bromma',
	'16858': 'Bromma',
	'16859': 'Bromma',
	'16860': 'Bromma',
	'16861': 'Bromma',
	'16862': 'Bromma',
	'16864': 'Bromma',
	'16865': 'Bromma',
	'16866': 'Bromma',
	'16867': 'Bromma',
	'16868': 'Bromma',
	'16869': 'Bromma',
	'16870': 'Bromma',
	'16871': 'Bromma',
	'16873': 'Bromma',
	'16874': 'Bromma',
	'16875': 'Bromma',
	'16876': 'Bromma',
	'16877': 'Bromma',
	'16930': 'Solna',
	'16931': 'Solna',
	'16932': 'Solna',
	'16933': 'Solna',
	'16934': 'Solna',
	'16935': 'Solna',
	'16936': 'Solna',
	'16937': 'Solna',
	'16938': 'Solna',
	'16939': 'Solna',
	'16940': 'Solna',
	'16950': 'Solna',
	'16951': 'Solna',
	'16952': 'Solna',
	'16953': 'Solna',
	'16954': 'Solna',
	'16955': 'Solna',
	'16956': 'Solna',
	'16957': 'Solna',
	'16958': 'Solna',
	'16959': 'Solna',
	'16960': 'Solna',
	'16961': 'Solna',
	'16962': 'Solna',
	'16963': 'Solna',
	'16964': 'Solna',
	'16965': 'Solna',
	'16966': 'Solna',
	'16967': 'Solna',
	'16968': 'Solna',
	'16969': 'Solna',
	'16970': 'Solna',
	'16971': 'Solna',
	'16972': 'Solna',
	'16973': 'Solna',
	'16974': 'Solna',
	'17062': 'Solna',
	'17063': 'Solna',
	'17065': 'Solna',
	'17066': 'Solna',
	'17067': 'Solna',
	'17068': 'Solna',
	'17069': 'Solna',
	'17070': 'Solna',
	'17071': 'Solna',
	'17072': 'Solna',
	'17073': 'Solna',
	'17074': 'Solna',
	'17075': 'Solna',
	'17076': 'Solna',
	'17077': 'Solna',
	'17078': 'Solna',
	'17079': 'Solna',
	'17141': 'Solna',
	'17142': 'Solna',
	'17143': 'Solna',
	'17144': 'Solna',
	'17145': 'Solna',
	'17147': 'Solna',
	'17148': 'Solna',
	'17149': 'Solna',
	'17150': 'Solna',
	'17151': 'Solna',
	'17152': 'Solna',
	'17153': 'Solna',
	'17154': 'Solna',
	'17155': 'Solna',
	'17156': 'Solna',
	'17157': 'Solna',
	'17158': 'Solna',
	'17159': 'Solna',
	'17160': 'Solna',
	'17161': 'Solna',
	'17162': 'Solna',
	'17163': 'Solna',
	'17164': 'Solna',
	'17165': 'Solna',
	'17166': 'Solna',
	'17167': 'Solna',
	'17168': 'Solna',
	'17170': 'Solna',
	'17171': 'Solna',
	'17172': 'Solna',
	'17173': 'Solna',
	'17230': 'Sundbyberg',
	'17231': 'Sundbyberg',
	'17232': 'Sundbyberg',
	'17233': 'Sundbyberg',
	'17234': 'Sundbyberg',
	'17235': 'Sundbyberg',
	'17236': 'Sundbyberg',
	'17237': 'Sundbyberg',
	'17238': 'Sundbyberg',
	'17239': 'Sundbyberg',
	'17240': 'Sundbyberg',
	'17241': 'Sundbyberg',
	'17262': 'Sundbyberg',
	'17263': 'Sundbyberg',
	'17264': 'Sundbyberg',
	'17265': 'Sundbyberg',
	'17266': 'Sundbyberg',
	'17267': 'Sundbyberg',
	'17268': 'Sundbyberg',
	'17269': 'Sundbyberg',
	'17270': 'Sundbyberg',
	'17271': 'Sundbyberg',
	'17272': 'Sundbyberg',
	'17273': 'Sundbyberg',
	'17274': 'Sundbyberg',
	'17275': 'Sundbyberg',
	'17276': 'Sundbyberg',
	'17277': 'Sundbyberg',
	'17278': 'Sundbyberg',
	'17279': 'Sundbyberg',
	'17441': 'Sundbyberg',
	'17442': 'Sundbyberg',
	'17443': 'Sundbyberg',
	'17444': 'Sundbyberg',
	'17445': 'Sundbyberg',
	'17446': 'Sundbyberg',
	'17447': 'Sundbyberg',
	'17448': 'Sundbyberg',
	'17449': 'Sundbyberg',
	'17450': 'Sundbyberg',
	'17451': 'Sundbyberg',
	'17452': 'Sundbyberg',
	'17453': 'Sundbyberg',
	'17454': 'Sundbyberg',
	'17455': 'Sundbyberg',
	'17456': 'Sundbyberg',
	'17457': 'Sundbyberg',
	'17458': 'Sundbyberg',
	'17459': 'Sundbyberg',
	'17460': 'Sundbyberg',
	'17461': 'Sundbyberg',
	'17462': 'Sundbyberg',
	'17463': 'Sundbyberg',
	'17464': 'Sundbyberg',
	'17541': 'Järfälla',
	'17543': 'Järfälla',
	'17544': 'Järfälla',
	'17545': 'Järfälla',
	'17546': 'Järfälla',
	'17547': 'Järfälla',
	'17548': 'Järfälla',
	'17549': 'Järfälla',
	'17550': 'Järfälla',
	'17551': 'Järfälla',
	'17552': 'Järfälla',
	'17553': 'Järfälla',
	'17554': 'Järfälla',
	'17555': 'Järfälla',
	'17556': 'Järfälla',
	'17557': 'Järfälla',
	'17560': 'Järfälla',
	'17561': 'Järfälla',
	'17562': 'Järfälla',
	'17563': 'Järfälla',
	'17564': 'Järfälla',
	'17565': 'Järfälla',
	'17566': 'Järfälla',
	'17567': 'Järfälla',
	'17568': 'Järfälla',
	'17569': 'Järfälla',
	'17579': 'Järfälla',
	'17668': 'Järfälla',
	'17669': 'Järfälla',
	'17670': 'Järfälla',
	'17671': 'Järfälla',
	'17672': 'Järfälla',
	'17673': 'Järfälla',
	'17674': 'Järfälla',
	'17675': 'Järfälla',
	'17676': 'Järfälla',
	'17677': 'Järfälla',
	'17730': 'Järfälla',
	'17731': 'Järfälla',
	'17732': 'Järfälla',
	'17733': 'Järfälla',
	'17734': 'Järfälla',
	'17735': 'Järfälla',
	'17736': 'Järfälla',
	'17737': 'Järfälla',
	'17738': 'Järfälla',
	'17739': 'Järfälla',
	'17740': 'Järfälla',
	'17741': 'Järfälla',
	'17742': 'Järfälla',
	'17743': 'Järfälla',
	'17750': 'Järfälla',
	'17751': 'Järfälla',
	'17752': 'Järfälla',
	'17753': 'Järfälla',
	'17754': 'Järfälla',
	'17755': 'Järfälla',
	'17756': 'Järfälla',
	'17757': 'Järfälla',
	'17758': 'Järfälla',
	'17759': 'Järfälla',
	'17760': 'Järfälla',
	'17761': 'Järfälla',
	'17762': 'Järfälla',
	'17763': 'Järfälla',
	'17764': 'Järfälla',
	'17770': 'Järfälla',
	'17771': 'Järfälla',
	'17830': 'Ekerö',
	'17831': 'Ekerö',
	'17832': 'Ekerö',
	'17833': 'Ekerö',
	'17834': 'Ekerö',
	'17835': 'Ekerö',
	'17836': 'Ekerö',
	'17837': 'Ekerö',
	'17838': 'Ekerö',
	'17839': 'Ekerö',
	'17840': 'Ekerö',
	'17841': 'Ekerö',
	'17851': 'Ekerö',
	'17852': 'Ekerö',
	'17853': 'Ekerö',
	'17854': 'Ekerö',
	'17890': 'Ekerö',
	'17891': 'Munsö',
	'17892': 'Adelsö',
	'17893': 'Drottningholm',
	'17960': 'Stenhamra',
	'17961': 'Stenhamra',
	'17962': 'Stenhamra',
	'17963': 'Stenhamra',
	'17965': 'Stenhamra',
	'17975': 'Skå',
	'17995': 'Svartsjö',
	'17996': 'Svartsjö',
	'17997': 'Färentuna',
	'17998': 'Färentuna',
	'18129': 'Lidingö',
	'18130': 'Lidingö',
	'18131': 'Lidingö',
	'18132': 'Lidingö',
	'18133': 'Lidingö',
	'18134': 'Lidingö',
	'18135': 'Lidingö',
	'18136': 'Lidingö',
	'18137': 'Lidingö',
	'18138': 'Lidingö',
	'18139': 'Lidingö',
	'18140': 'Lidingö',
	'18141': 'Lidingö',
	'18142': 'Lidingö',
	'18143': 'Lidingö',
	'18144': 'Lidingö',
	'18145': 'Lidingö',
	'18146': 'Lidingö',
	'18147': 'Lidingö',
	'18148': 'Lidingö',
	'18150': 'Lidingö',
	'18151': 'Lidingö',
	'18155': 'Lidingö',
	'18156': 'Lidingö',
	'18157': 'Lidingö',
	'18158': 'Lidingö',
	'18159': 'Lidingö',
	'18160': 'Lidingö',
	'18161': 'Lidingö',
	'18162': 'Lidingö',
	'18163': 'Lidingö',
	'18164': 'Lidingö',
	'18165': 'Lidingö',
	'18166': 'Lidingö',
	'18190': 'Lidingö',
	'18230': 'Danderyd',
	'18231': 'Danderyd',
	'18232': 'Danderyd',
	'18233': 'Danderyd',
	'18234': 'Danderyd',
	'18235': 'Danderyd',
	'18236': 'Danderyd',
	'18237': 'Danderyd',
	'18238': 'Danderyd',
	'18239': 'Danderyd',
	'18245': 'Enebyberg',
	'18246': 'Enebyberg',
	'18247': 'Enebyberg',
	'18248': 'Enebyberg',
	'18249': 'Enebyberg',
	'18250': 'Danderyd',
	'18252': 'Danderyd',
	'18253': 'Danderyd',
	'18254': 'Djursholm',
	'18255': 'Djursholm',
	'18256': 'Danderyd',
	'18257': 'Danderyd',
	'18260': 'Djursholm',
	'18261': 'Djursholm',
	'18262': 'Djursholm',
	'18263': 'Djursholm',
	'18264': 'Djursholm',
	'18265': 'Djursholm',
	'18266': 'Djursholm',
	'18267': 'Djursholm',
	'18268': 'Djursholm',
	'18269': 'Djursholm',
	'18270': 'Stocksund',
	'18273': 'Stocksund',
	'18274': 'Stocksund',
	'18275': 'Stocksund',
	'18276': 'Stocksund',
	'18277': 'Stocksund',
	'18278': 'Stocksund',
	'18279': 'Stocksund',
	'18330': 'Täby',
	'18331': 'Täby',
	'18332': 'Täby',
	'18333': 'Täby',
	'18334': 'Täby',
	'18335': 'Täby',
	'18336': 'Täby',
	'18337': 'Täby',
	'18339': 'Täby',
	'18348': 'Täby',
	'18349': 'Täby',
	'18350': 'Täby',
	'18351': 'Täby',
	'18352': 'Täby',
	'18353': 'Täby',
	'18354': 'Täby',
	'18355': 'Täby',
	'18356': 'Täby',
	'18357': 'Täby',
	'18358': 'Täby',
	'18359': 'Täby',
	'18360': 'Täby',
	'18361': 'Täby',
	'18362': 'Täby',
	'18363': 'Täby',
	'18364': 'Täby',
	'18365': 'Täby',
	'18366': 'Täby',
	'18367': 'Täby',
	'18368': 'Täby',
	'18369': 'Täby',
	'18370': 'Täby',
	'18377': 'Täby',
	'18378': 'Täby',
	'18379': 'Täby',
	'18430': 'Åkersberga',
	'18431': 'Åkersberga',
	'18432': 'Åkersberga',
	'18433': 'Åkersberga',
	'18434': 'Åkersberga',
	'18435': 'Åkersberga',
	'18436': 'Åkersberga',
	'18437': 'Åkersberga',
	'18438': 'Åkersberga',
	'18439': 'Åkersberga',
	'18440': 'Åkersberga',
	'18441': 'Åkersberga',
	'18442': 'Åkersberga',
	'18443': 'Åkersberga',
	'18444': 'Åkersberga',
	'18450': 'Åkersberga',
	'18451': 'Österskär',
	'18452': 'Österskär',
	'18460': 'Åkersberga',
	'18461': 'Åkersberga',
	'18462': 'Åkersberga',
	'18463': 'Åkersberga',
	'18470': 'Åkersberga',
	'18491': 'Åkersberga',
	'18492': 'Åkersberga',
	'18493': 'Åkersberga',
	'18494': 'Åkersberga',
	'18495': 'Ljusterö',
	'18496': 'Åkersberga',
	'18497': 'Ljusterö',
	'18499': 'Husarö',
	'18531': 'Vaxholm',
	'18532': 'Vaxholm',
	'18533': 'Vaxholm',
	'18534': 'Vaxholm',
	'18535': 'Vaxholm',
	'18537': 'Vaxholm',
	'18539': 'Vaxholm',
	'18541': 'Vaxholm',
	'18551': 'Vaxholm',
	'18591': 'Vaxholm',
	'18592': 'Vaxholm',
	'18593': 'Vaxholm',
	'18594': 'Vaxholm',
	'18595': 'Vaxholm',
	'18599': 'Vaxholm',
	'18630': 'Vallentuna',
	'18631': 'Vallentuna',
	'18632': 'Vallentuna',
	'18633': 'Vallentuna',
	'18634': 'Vallentuna',
	'18635': 'Vallentuna',
	'18636': 'Vallentuna',
	'18637': 'Vallentuna',
	'18638': 'Vallentuna',
	'18639': 'Vallentuna',
	'18640': 'Vallentuna',
	'18641': 'Vallentuna',
	'18642': 'Vallentuna',
	'18643': 'Vallentuna',
	'18644': 'Vallentuna',
	'18645': 'Vallentuna',
	'18646': 'Vallentuna',
	'18647': 'Vallentuna',
	'18649': 'Vallentuna',
	'18650': 'Vallentuna',
	'18651': 'Vallentuna',
	'18652': 'Vallentuna',
	'18653': 'Vallentuna',
	'18654': 'Vallentuna',
	'18655': 'Vallentuna',
	'18656': 'Vallentuna',
	'18660': 'Vallentuna',
	'18670': 'Brottby',
	'18691': 'Vallentuna',
	'18692': 'Vallentuna',
	'18693': 'Vallentuna',
	'18694': 'Vallentuna',
	'18695': 'Vallentuna',
	'18696': 'Vallentuna',
	'18697': 'Brottby',
	'18730': 'Täby',
	'18731': 'Täby',
	'18732': 'Täby',
	'18733': 'Täby',
	'18734': 'Täby',
	'18735': 'Täby',
	'18736': 'Täby',
	'18737': 'Täby',
	'18738': 'Täby',
	'18740': 'Täby',
	'18741': 'Täby',
	'18742': 'Täby',
	'18743': 'Täby',
	'18744': 'Täby',
	'18745': 'Täby',
	'18746': 'Täby',
	'18750': 'Täby',
	'18751': 'Täby',
	'18752': 'Täby',
	'18753': 'Täby',
	'18754': 'Täby',
	'18762': 'Täby',
	'18763': 'Täby',
	'18764': 'Täby',
	'18765': 'Täby',
	'18766': 'Täby',
	'18767': 'Täby',
	'18768': 'Täby',
	'18769': 'Täby',
	'18770': 'Täby',
	'18772': 'Täby',
	'18773': 'Täby',
	'18774': 'Täby',
	'18775': 'Täby',
	'18776': 'Täby',
	'18777': 'Täby',
	'19060': 'Stockholm-ARLANDA',
	'19133': 'Sollentuna',
	'19134': 'Sollentuna',
	'19135': 'Sollentuna',
	'19136': 'Sollentuna',
	'19138': 'Sollentuna',
	'19139': 'Sollentuna',
	'19140': 'Sollentuna',
	'19141': 'Sollentuna',
	'19142': 'Sollentuna',
	'19143': 'Sollentuna',
	'19144': 'Sollentuna',
	'19145': 'Sollentuna',
	'19146': 'Sollentuna',
	'19147': 'Sollentuna',
	'19148': 'Sollentuna',
	'19149': 'Sollentuna',
	'19150': 'Sollentuna',
	'19160': 'Sollentuna',
	'19161': 'Sollentuna',
	'19162': 'Sollentuna',
	'19163': 'Sollentuna',
	'19164': 'Sollentuna',
	'19248': 'Sollentuna',
	'19251': 'Sollentuna',
	'19252': 'Sollentuna',
	'19253': 'Sollentuna',
	'19254': 'Sollentuna',
	'19255': 'Sollentuna',
	'19256': 'Sollentuna',
	'19257': 'Sollentuna',
	'19258': 'Sollentuna',
	'19259': 'Sollentuna',
	'19266': 'Sollentuna',
	'19267': 'Sollentuna',
	'19268': 'Sollentuna',
	'19269': 'Sollentuna',
	'19270': 'Sollentuna',
	'19271': 'Sollentuna',
	'19272': 'Sollentuna',
	'19273': 'Sollentuna',
	'19274': 'Sollentuna',
	'19275': 'Sollentuna',
	'19276': 'Sollentuna',
	'19277': 'Sollentuna',
	'19278': 'Sollentuna',
	'19279': 'Sollentuna',
	'19330': 'Sigtuna',
	'19331': 'Sigtuna',
	'19332': 'Sigtuna',
	'19333': 'Sigtuna',
	'19334': 'Sigtuna',
	'19335': 'Sigtuna',
	'19336': 'Sigtuna',
	'19340': 'Sigtuna',
	'19341': 'Sigtuna',
	'19391': 'Sigtuna',
	'19430': 'Upplands VÄSBY',
	'19431': 'Upplands VÄSBY',
	'19432': 'Upplands VÄSBY',
	'19433': 'Upplands VÄSBY',
	'19434': 'Upplands VÄSBY',
	'19435': 'Upplands VÄSBY',
	'19436': 'Upplands VÄSBY',
	'19437': 'Upplands VÄSBY',
	'19438': 'Upplands VÄSBY',
	'19439': 'Upplands VÄSBY',
	'19440': 'Upplands VÄSBY',
	'19441': 'Upplands VÄSBY',
	'19442': 'Upplands VÄSBY',
	'19443': 'Upplands VÄSBY',
	'19444': 'Upplands VÄSBY',
	'19445': 'Upplands VÄSBY',
	'19446': 'Upplands VÄSBY',
	'19447': 'Upplands VÄSBY',
	'19451': 'Upplands VÄSBY',
	'19452': 'Upplands VÄSBY',
	'19453': 'Upplands VÄSBY',
	'19454': 'Upplands VÄSBY',
	'19455': 'Upplands VÄSBY',
	'19456': 'Upplands VÄSBY',
	'19457': 'Upplands VÄSBY',
	'19460': 'Upplands VÄSBY',
	'19461': 'Upplands VÄSBY',
	'19462': 'Upplands VÄSBY',
	'19463': 'Upplands VÄSBY',
	'19464': 'Upplands VÄSBY',
	'19465': 'Upplands VÄSBY',
	'19466': 'Upplands VÄSBY',
	'19467': 'Upplands VÄSBY',
	'19468': 'Upplands VÄSBY',
	'19469': 'Upplands VÄSBY',
	'19471': 'Upplands VÄSBY',
	'19472': 'Upplands VÄSBY',
	'19473': 'Upplands VÄSBY',
	'19474': 'Upplands VÄSBY',
	'19475': 'Upplands VÄSBY',
	'19476': 'Upplands VÄSBY',
	'19477': 'Upplands VÄSBY',
	'19478': 'Upplands VÄSBY',
	'19479': 'Upplands VÄSBY',
	'19491': 'Upplands VÄSBY',
	'19492': 'Upplands VÄSBY',
	'19530': 'Märsta',
	'19531': 'Märsta',
	'19532': 'Märsta',
	'19533': 'Märsta',
	'19534': 'Märsta',
	'19535': 'Märsta',
	'19536': 'Märsta',
	'19540': 'Märsta',
	'19541': 'Märsta',
	'19542': 'Märsta',
	'19543': 'Märsta',
	'19544': 'Märsta',
	'19545': 'Märsta',
	'19546': 'Märsta',
	'19547': 'Märsta',
	'19550': 'Märsta',
	'19551': 'Märsta',
	'19552': 'Märsta',
	'19553': 'Märsta',
	'19554': 'Märsta',
	'19555': 'Märsta',
	'19556': 'Märsta',
	'19557': 'Märsta',
	'19558': 'Märsta',
	'19560': 'Arlandastad',
	'19565': 'Steningehöjden',
	'19570': 'Rosersberg',
	'19571': 'Rosersberg',
	'19572': 'Rosersberg',
	'19591': 'Märsta',
	'19592': 'Märsta',
	'19593': 'Märsta',
	'19594': 'Märsta',
	'19595': 'Rosersberg',
	'19596': 'Rosersberg',
	'19630': 'Kungsängen',
	'19631': 'Kungsängen',
	'19632': 'Kungsängen',
	'19633': 'Kungsängen',
	'19634': 'Kungsängen',
	'19635': 'Kungsängen',
	'19636': 'Kungsängen',
	'19637': 'Kungsängen',
	'19638': 'Kungsängen',
	'19639': 'Kungsängen',
	'19640': 'Kungsängen',
	'19641': 'Kungsängen',
	'19691': 'Kungsängen',
	'19692': 'Kungsängen',
	'19693': 'Kungsängen',
	'19730': 'Bro',
	'19731': 'Bro',
	'19732': 'Bro',
	'19734': 'Bro',
	'19735': 'Bro',
	'19736': 'Bro',
	'19740': 'Bro',
	'19791': 'Bro',
	'19792': 'Bro',
	'19793': 'Bro',
	'75217': 'Uppsala',
	'75218': 'Uppsala',
	'75219': 'Uppsala',
	'75220': 'Uppsala',
	'75221': 'Uppsala',
	'75222': 'Uppsala',
	'75223': 'Uppsala',
	'75224': 'Uppsala',
	'75225': 'Uppsala',
	'75226': 'Uppsala',
	'75227': 'Uppsala',
	'75228': 'Uppsala',
	'75229': 'Uppsala',
	'75230': 'Uppsala',
	'75231': 'Uppsala',
	'75232': 'Uppsala',
	'75233': 'Uppsala',
	'75234': 'Uppsala',
	'75235': 'Uppsala',
	'75236': 'Uppsala',
	'75237': 'Uppsala',
	'75238': 'Uppsala',
	'75239': 'Uppsala',
	'75240': 'Uppsala',
	'75241': 'Uppsala',
	'75242': 'Uppsala',
	'75243': 'Uppsala',
	'75244': 'Uppsala',
	'75258': 'Uppsala',
	'75260': 'Uppsala',
	'75261': 'Uppsala',
	'75262': 'Uppsala',
	'75263': 'Uppsala',
	'75264': 'Uppsala',
	'75265': 'Uppsala',
	'75266': 'Uppsala',
	'75267': 'Uppsala',
	'75268': 'Uppsala',
	'75271': 'Uppsala',
	'75272': 'Uppsala',
	'75273': 'Uppsala',
	'75308': 'Uppsala',
	'75309': 'Uppsala',
	'75310': 'Uppsala',
	'75311': 'Uppsala',
	'75312': 'Uppsala',
	'75313': 'Uppsala',
	'75314': 'Uppsala',
	'75315': 'Uppsala',
	'75316': 'Uppsala',
	'75317': 'Uppsala',
	'75318': 'Uppsala',
	'75319': 'Uppsala',
	'75320': 'Uppsala',
	'75321': 'Uppsala',
	'75322': 'Uppsala',
	'75323': 'Uppsala',
	'75324': 'Uppsala',
	'75325': 'Uppsala',
	'75326': 'Uppsala',
	'75327': 'Uppsala',
	'75328': 'Uppsala',
	'75329': 'Uppsala',
	'75330': 'Uppsala',
	'75331': 'Uppsala',
	'75332': 'Uppsala',
	'75333': 'Uppsala',
	'75334': 'Uppsala',
	'75335': 'Uppsala',
	'75336': 'Uppsala',
	'75337': 'Uppsala',
	'75350': 'Uppsala',
	'75418': 'Uppsala',
	'75419': 'Uppsala',
	'75420': 'Uppsala',
	'75421': 'Uppsala',
	'75422': 'Uppsala',
	'75423': 'Uppsala',
	'75424': 'Uppsala',
	'75425': 'Uppsala',
	'75426': 'Uppsala',
	'75427': 'Uppsala',
	'75428': 'Uppsala',
	'75429': 'Uppsala',
	'75430': 'Uppsala',
	'75431': 'Uppsala',
	'75432': 'Uppsala',
	'75433': 'Uppsala',
	'75434': 'Uppsala',
	'75435': 'Uppsala',
	'75436': 'Uppsala',
	'75437': 'Uppsala',
	'75439': 'Uppsala',
	'75440': 'Uppsala',
	'75441': 'Uppsala',
	'75442': 'Uppsala',
	'75443': 'Uppsala',
	'75445': 'Uppsala',
	'75446': 'Uppsala',
	'75447': 'Uppsala',
	'75448': 'Uppsala',
	'75449': 'Uppsala',
	'75450': 'Uppsala',
	'75452': 'Uppsala',
	'75453': 'Uppsala',
	'75454': 'Uppsala',
	'75591': 'Uppsala',
	'75592': 'Uppsala',
	'75593': 'Uppsala',
	'75594': 'Uppsala',
	'75595': 'Uppsala',
	'75596': 'Uppsala',
	'75597': 'Uppsala',
	'75598': 'Uppsala',
	'75642': 'Uppsala',
	'75643': 'Uppsala',
	'75645': 'Uppsala',
	'75646': 'Uppsala',
	'75647': 'Uppsala',
	'75648': 'Uppsala',
	'75649': 'Uppsala',
	'75650': 'Uppsala',
	'75651': 'Uppsala',
	'75652': 'Uppsala',
	'75653': 'Uppsala',
	'75654': 'Uppsala',
	'75655': 'Uppsala',
	'75752': 'Uppsala',
	'75753': 'Uppsala',
	'75754': 'Uppsala',
	'75755': 'Uppsala',
	'75756': 'Uppsala',
	'75757': 'Uppsala',
	'75758': 'Uppsala',
	'75759': 'Uppsala'
});
